import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AuthGuard } from '@tbtk/auth';

import { ShareRedirectComponent } from './common/share-redirect/share-redirect.component';
import { PageWrapperComponent } from './page-wrapper.component';
import { OnlyOfficeComponent } from './pages/storage/onlyoffice/onlyoffice.component';

export const routes: Routes = [
  { path: '', redirectTo: '/depom', pathMatch: 'full' },
  {
    path: '',
    component: PageWrapperComponent,
    canActivate: [AuthGuard],
    children: [
      { path: 'depom', loadChildren: () => import('./pages/storage/storage.module').then((m) => m.StorageModule) },
      { path: 'paylasimlar', loadChildren: () => import('./pages/shares/shares.module').then((m) => m.SharesModule) },
      { path: 'gruplarim', loadChildren: () => import('./pages/groups/my-groups/my-groups.module').then((m) => m.MyGroupsModule) },
      { path: 'favorilerim', loadChildren: () => import('./pages/favorites/favorites.module').then((m) => m.FavoritesModule) },
      { path: 'cop-kutusu', loadChildren: () => import('./pages/trash/trash.module').then((m) => m.TrashModule) },
      {
        path: 'sifreli-depo',
        loadChildren: () => import('./pages/encrypted-storage/enrypted-storage.module').then((m) => m.EncryptedStorageModule),
      },
      { path: 'profil-ayarlari', loadChildren: () => import('./pages/profile/profile-settings/profile-settings.module').then((m) => m.ProfileSettingsModule) },
      { path: 'sifreli-depo-guncelleme', loadChildren: () => import('./pages/profile/password-forms/password-forms.module').then((m) => m.PasswordFormsModule) },
      { path: 'guvenlik-ayarlari', loadChildren: () => import('./pages/profile/security-settings/security-settings.module').then((m) => m.SecuritySettingsModule) },
      { path: 'secure-storage/reset-crypto-password', loadChildren: () => import('./pages/profile/password-forms/password-forms.module').then((m) => m.PasswordFormsModule) },
      { path: 'yardim-merkezi', loadChildren: () => import('./pages/profile/help/help.module').then((m) => m.HelpModule) },
      { path: 'yakin-tarihli', loadChildren: () => import('./pages/recents/recents.module').then((m) => m.RecentsModule) },
      { path: 'genel-bakis', loadChildren: () => import('./pages/dashboard/dashboard.module').then((m) => m.DashboardModule) },

      { path: 'shares/public/share/:id', component: ShareRedirectComponent },

      { path: 'safir-not', loadChildren: () => import('./pages/safir-note/note.module').then((m) => m.NoteModule) },
      { path: 'safir-posta', loadChildren: () => import('./pages/safir-posta/safir-posta.module').then((m) => m.SafirPostaModule) },
      { path: 'safir-kimlik', loadChildren: () => import('./pages/safir-kimlik/safir-kimlik.module').then((m) => m.SafirKimlikModule) },
    ],
  },
  { path: 'office/:id', component: OnlyOfficeComponent },
  { path: 'baglanti-paylasimi', loadChildren: () => import('./pages/shares-wrapper/publicly-shared/publicy-shared.module').then((m) => m.PubliclySharedModule) },
  { path: '**', redirectTo: '/depom', pathMatch: 'full' },
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { scrollPositionRestoration: 'enabled' })],
  exports: [RouterModule],
})
export class AppRoutingModule {}
